import { gql } from '@apollo/client';

export default gql`
  mutation exoItemsCsv($from: Int!, $to: Int!) {
    exoItemsCsv(from: $from, to: $to)
  }
`;
